import { Link } from "react-router-dom";
import { XCircle } from "@phosphor-icons/react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-brand-bg dot-bg flex items-center justify-center p-6" data-testid="payment-cancel-page">
      <div className="bg-white border border-brand-border rounded-3xl p-10 max-w-md w-full text-center">
        <XCircle size={64} weight="duotone" className="text-brand-textMuted mx-auto" />
        <h1 className="font-heading text-2xl font-bold mt-4">Payment cancelled</h1>
        <p className="text-brand-text/70 mt-2">No charge was made. You can try again anytime.</p>
        <Link to="/app/billing" className="mt-8 inline-flex items-center gap-2 bg-brand-primary hover:bg-brand-primaryHover text-white rounded-full px-6 py-3 font-semibold" data-testid="cancel-retry">
          Try again
        </Link>
      </div>
    </div>
  );
}
